// extracted by mini-css-extract-plugin
export default {"red":"Class_red__XS-4x"};